module.exports = __webpack_public_path__ + "img/06_watermelon.091f0282.png";